import React, { useEffect, useState } from "react";
import apiClient from '../../acciones/apiClient';
import "./perfilUsu.css";
import { NavBar } from "../../componentes/navbar";
import { ImgCabecera } from "../../componentes/imgCabecera/imgCabe";
import imgProyecto from "../../img/card.png";
import { jwtDecode } from "jwt-decode";
import { CardPerfilUsuario } from "../../componentes/cardPerfilUsu/cardPerfilUsu";

export const PerfilUsuario = () => {
    const [perfil, setPerfil] = useState({
        tablon: "", // Inicializa como string vacío
    });

    const [loading, setLoading] = useState(true); // Estado de carga
    const [error, setError] = useState(null); // Estado para errores
    const [newPost, setNewPost] = useState(""); // Nueva publicación
    const [editMode, setEditMode] = useState(false);
    const [rango, setRango] = useState(null);
    const [formData, setFormData] = useState({
        nombre_usuario: "",
        descripcion: "",
        imagen_perfil: null,
    });
    const [projectModalOpen, setProjectModalOpen] = useState(false); // Controla la ventana modal
    const [projectFormData, setProjectFormData] = useState({
        cover: null,
        title: "",
        description: "",
        visibility: "publico",
        seriesType: "manhwa",
        isAdult: false,
        author: "",
        year: "",
        altName: "",
        studio: "",
        demographics: "",
        genres: []
    });

    const handleGenreChange = (e) => {
        const { value, checked } = e.target;

        setProjectFormData(prev => {
            if (checked) {
                // Si el checkbox está marcado, añade el género al array
                return { ...prev, genres: [...prev.genres, value] };
            } else {
                // Si el checkbox se desmarca, quita el género del array
                return { ...prev, genres: prev.genres.filter(genre => genre !== value) };
            }
        });
    };

    useEffect(() => {
        const fetchPerfilYProyectos = async () => {
            try {
                const token = localStorage.getItem("token");
                if (!token) throw new Error("No se encontró un token válido en localStorage.");

                const decodedToken = jwtDecode(token);
                const userId = decodedToken.id;
                console.log("El id del usuario es: ",userId);
                setRango(decodedToken.rango);
                const perfilResponse = await apiClient.get(
                    `/usuarios/perfil/${userId}`
                );
                //const perfilData = perfilResponse.data;
                console.log("Datos del perfil recibidos:", perfilResponse);
                const proyectosResponse = await apiClient.get(
                    `/proyectos/mis-proyectos`,
                    { params: { userId } }
                );
                const proyectosData = proyectosResponse.data;
                console.log("Proyectos recibidos:", proyectosData);

                console.log("Proyectos obtenidos:", proyectosResponse.data); // Verifica los datos aquí

                setPerfil({
                    ...perfilResponse.data,
                    proyectos: perfilResponse.data.proyectos,
                });
            } catch (err) {
                console.error("Error en fetchPerfilYProyectos:", err);
                setError("Error al cargar el perfil o los proyectos. Intente nuevamente.");
            } finally {
                setLoading(false);
            }
        };

        fetchPerfilYProyectos();
    }, []);




    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        console.log("Tamaño original de la imagen:", file.size / 1024, "KB");
        console.log("Formato original de la imagen:", file.type);

        const reader = new FileReader();
        reader.onload = async (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                // Redimensionar la imagen
                const maxWidth = 300;
                const maxHeight = 300;
                let { width, height } = img;

                if (width > height) {
                    if (width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                ctx.drawImage(img, 0, 0, width, height);

                // Convertir a formato .webp
                canvas.toBlob(
                    (blob) => {
                        console.log("Tamaño final de la imagen:", blob.size / 1024, "KB");
                        console.log("Formato final de la imagen:", blob.type);

                        setFormData((prev) => ({ ...prev, imagen_perfil: blob }));
                    },
                    "image/webp",
                    0.8 // Calidad
                );
            };
        };
        reader.readAsDataURL(file);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("nombre_usuario", formData.nombre_usuario);
        data.append("descripcion", formData.descripcion);
        data.append("tablon", JSON.stringify(formData.tablon));
        if (formData.imagen_perfil) {
            data.append("imagen_perfil", formData.imagen_perfil);
        }

        console.log("Datos enviados al backend:", Array.from(data.entries())); // Verifica los datos enviados

        try {
            const response = await apiClient.put(
                `/usuarios/perfil/${perfil.user_id}`,
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            alert(response.data.mensaje);
            setPerfil(response.data.usuario);
            setEditMode(false);
        } catch (error) {
            console.error("Error al actualizar perfil:", error);
        }
    };


    if (loading) return <p>Cargando perfil...</p>;

    if (error) return <p>Error: {error}</p>;


    const handleProjectChange = (e) => {
        const { name, value, type, checked } = e.target;
        setProjectFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleProjectFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        console.log("Tamaño original de la imagen:", file.size / 1024, "KB");
        console.log("Formato original de la imagen:", file.type);

        const reader = new FileReader();
        reader.onload = async (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                // Redimensionar la imagen
                const maxWidth = 600; // Ajusta el tamaño máximo según sea necesario
                const maxHeight = 600;
                let { width, height } = img;

                if (width > height) {
                    if (width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                ctx.drawImage(img, 0, 0, width, height);

                // Convertir a formato .webp
                canvas.toBlob(
                    (blob) => {
                        console.log("Tamaño final de la imagen:", blob.size / 1024, "KB");
                        console.log("Formato final de la imagen:", blob.type);

                        // Actualizar el estado del formulario
                        setProjectFormData((prev) => ({ ...prev, cover: blob }));
                    },
                    "image/webp",
                    0.8 // Calidad de compresión
                );
            };
        };
        reader.readAsDataURL(file);
    };


    const handleSubmitProject = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("userId", perfil.user_id); // ID del usuario conectado
        data.append("title", projectFormData.title);
        data.append("description", projectFormData.description);
        data.append("visibility", projectFormData.visibility);
        data.append("seriesType", projectFormData.seriesType);
        data.append("isAdult", projectFormData.isAdult);
        data.append("author", projectFormData.author);
        data.append("year", projectFormData.year);
        data.append("altName", projectFormData.altName);
        data.append("studio", projectFormData.studio);
        data.append("demographics", projectFormData.demographics);

        // Añade los géneros al FormData
        projectFormData.genres.forEach(genre => {
            data.append("genders", genre);
        });

        if (projectFormData.cover) {
            data.append("cover", projectFormData.cover);
        }

        try {
            const response = await apiClient.post("/proyectos", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            alert("¡Proyecto subido con éxito!");

            // Actualizar la lista de proyectos del perfil
            setPerfil((prev) => ({
                ...prev,
                proyectos: [...prev.proyectos, response.data.proyecto],
            }));

            setProjectModalOpen(false); // Cierra la ventana modal
        } catch (error) {
            console.error("Error al subir el proyecto:", error);
            alert("Hubo un problema al subir el proyecto. Intenta nuevamente.");
        }
    };



    console.log("El rango del usuario es: ",rango);
    // Mostrar contenido específico según el rango
    if (rango === "afiliado") {
        // Vista para usuarios afiliados
        return (
            <div>
                <ImgCabecera />
                <NavBar />

                <div className="perfilFamiContainer">
                    <div className="perfilFamiCartel">
                        <img
                            src={perfil.imagen_perfil}
                            alt={perfil.nombre_usuario}
                        />
                    </div>
                    {editMode ? (
                        <div className="modal-overlayPerfilUsu">
                            <div className="modal">
                                <form onSubmit={handleSubmit} className="formEditarPerfil">
                                    <h2>Perfil</h2>
                                    <input
                                        type="file"
                                        name="imagen_perfil"
                                        onChange={handleFileChange}
                                    />
                                    <br /><br />
                                    <h2>Nombre de Usuario</h2>
                                    <input
                                        type="text"
                                        name="nombre_usuario"
                                        value={formData.nombre_usuario}
                                        onChange={handleInputChange}
                                        placeholder="Nombre de usuario"
                                    />
                                    <br /><br />
                                    <h2>Descripción</h2>
                                    <textarea
                                        name="descripcion"
                                        value={formData.descripcion}
                                        onChange={handleInputChange}
                                        placeholder="Descripción"
                                    />


                                    <button type="submit" className="boton-pequeño">Guardar cambios</button>
                                    <button onClick={() => setEditMode(false)} className="boton-pequeño">Cancelar</button>
                                </form>
                            </div>
                        </div>
                    ) : (
                        <div className="nameInfoPerfilFamiCar">
                            <h1>{perfil.nombre_usuario}</h1>
                            <p>{perfil.descripcion || "Sin descripción disponible."}</p>
                            <button onClick={() => setEditMode(true)}>Editar perfil</button>
                        </div>
                    )}
                </div>

                <div className="tablonPerfilFami">
                    <h2>Tablón</h2>
                    {perfil.tablon ? (
                        <div className="tablonEscribir">
                            <p>{perfil.tablon}</p>
                        </div>
                    ) : (
                        <p>No hay publicaciones en el tablón.</p>
                    )}

                    {/* Formulario para actualizar el tablón */}
                    <form
                        onSubmit={async (e) => {
                            e.preventDefault();
                            try {
                                const response = await apiClient.put(
                                    `/usuarios/perfil/${perfil.user_id}`,
                                    { tablon: newPost }, // Enviar el nuevo texto del tablón
                                    {
                                        headers: { "Content-Type": "application/json" },
                                    }
                                );
                                alert("Tablón actualizado con éxito.");
                                setPerfil(response.data.usuario);
                                setNewPost(""); // Limpia el campo después de actualizar
                            } catch (error) {
                                console.error("Error al actualizar el tablón:", error);
                            }
                        }}
                    >
                        <textarea
                            value={newPost}
                            onChange={(e) => setNewPost(e.target.value)}
                            placeholder="Escribe algo para tu tablón..."
                            rows="3"
                            required
                        />
                        <br />
                        <button type="submit">Actualizar</button>
                    </form>
                </div>



                <div className="ultimosProyectosPerfilFami">
                    <h2>Últimos Proyectos</h2>
                    {perfil.proyectos && perfil.proyectos.length > 0 ? (
                        perfil.proyectos.map((proyecto) => (
                            <CardPerfilUsuario
                                key={proyecto.proyecto_id}
                                titulo={proyecto.titulo}
                                portada={proyecto.portada} // Aquí llega el buffer o base64
                                proyectoId={proyecto.proyecto_id}
                            />
                        ))
                    ) : (
                        <p>No hay proyectos disponibles.</p>
                    )}
                    <br />
                    <button onClick={() => setProjectModalOpen(true)}>Subir nuevo proyecto</button>
                </div>


                {projectModalOpen && (
                    <div className="modal-overlayPerfilUsu">
                        <div className="modal">
                            <form onSubmit={handleSubmitProject}>
                                <div className="nuevo-proyectoAdmin2">
                                    <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                                    <div className="form-containerAdmin2">
                                        <h2>Nuevo Proyecto</h2>
                                        <div className="left-sideAdmin2">
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="cover">Portada</label>
                                                <input
                                                    type="file"
                                                    name="cover"
                                                    onChange={handleProjectFileChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="title">Título</label>
                                                <input
                                                    type="text"
                                                    id="title"
                                                    name="title"
                                                    placeholder="Agregar texto"
                                                    value={projectFormData.title}
                                                    onChange={handleProjectChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="description">Descripción</label>
                                                <textarea
                                                    id="description"
                                                    name="description"
                                                    placeholder="Agregar texto"
                                                    value={projectFormData.description}
                                                    onChange={handleProjectChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="visibility">Visibilidad</label>
                                                <select
                                                    id="visibility"
                                                    name="visibility"
                                                    value={projectFormData.visibility}
                                                    onChange={handleProjectChange}
                                                >
                                                    <option value="publico">Público</option>
                                                    <option value="privado">Privado</option>
                                                </select>
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="seriesType">Tipo de serie</label>
                                                <select
                                                    id="seriesType"
                                                    name="seriesType"
                                                    value={projectFormData.seriesType}
                                                    onChange={handleProjectChange}
                                                >
                                                    <option value="manga">Manga</option>
                                                    <option value="manhuas">Manhuas</option>
                                                    <option value="manhwa">Manhwa</option>
                                                    <option value="novela">Novela</option>
                                                </select>
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="isAdult">+18</label>
                                                <input
                                                    type="checkbox"
                                                    id="isAdult"
                                                    name="isAdult"
                                                    checked={projectFormData.isAdult}
                                                    onChange={(e) => setProjectFormData({ ...projectFormData, isAdult: e.target.checked })}
                                                />
                                            </div>
                                        </div>
                                        <div className="right-sideAdmin2">
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="author">Autor</label>
                                                <input
                                                    type="text"
                                                    id="author"
                                                    name="author"
                                                    placeholder="Agregar texto"
                                                    value={projectFormData.author}
                                                    onChange={handleProjectChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="year">Año</label>
                                                <input
                                                    type="number"
                                                    id="year"
                                                    name="year"
                                                    placeholder="Agregar número"
                                                    value={projectFormData.year}
                                                    onChange={handleProjectChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="altName">Nombre alternativo</label>
                                                <input
                                                    type="text"
                                                    id="altName"
                                                    name="altName"
                                                    placeholder="Agregar texto"
                                                    value={projectFormData.altName}
                                                    onChange={handleProjectChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="studio">Estudio</label>
                                                <input
                                                    type="text"
                                                    id="studio"
                                                    name="studio"
                                                    placeholder="Agregar texto"
                                                    value={projectFormData.studio}
                                                    onChange={handleProjectChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="demographics">Demografía</label>
                                                <textarea
                                                    id="demographics"
                                                    name="demographics"
                                                    placeholder="Agregar texto"
                                                    value={projectFormData.demographics}
                                                    onChange={handleProjectChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin3">
                                                <label htmlFor="project">Seleccionar Género</label>
                                                <div className="radio-groupSeriesPopu">
                                                    {['+18', 'Aventura', 'Acción', 'Bestias', 'Comedia', 'Demonios', 'Deportes', 'Drama',
                                                        'Escolares', 'Fantasía', 'Harem', 'Magia', 'Misterio', 'Moderno', 'One-shot',
                                                        'Psicológicos', 'Reencarnación', 'Romance', 'Transmigración', 'Tragedia',
                                                        'Thriller', 'Smut', 'Slice of Life', 'Sobrenatural', 'Vampiros', 'Venganza']
                                                        .map(genre => (
                                                            <label key={genre}>
                                                                <input
                                                                    type="checkbox"
                                                                    value={genre}
                                                                    checked={projectFormData.genres.includes(genre)}
                                                                    onChange={handleGenreChange}
                                                                /> {genre}
                                                            </label>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="create-project-buttonAdmin2">Crear Proyecto</button>
                                    <button onClick={() => setProjectModalOpen(false)} className="cancel-project-buttonAdmin2">Cancelar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

            </div>
        );
    } else {
        // Vista para usuarios con otro rango
        return (
            <div>
                <ImgCabecera />
                <NavBar />
                <div className="PerfilUsuario">
                    <img
                        src={perfil.imagen_perfil || imgProyecto} // Imagen predeterminada si no hay imagen
                        alt={perfil.nombre_usuario}
                        onError={(e) => {
                            e.target.src = imgProyecto; // Imagen predeterminada si falla la carga
                        }}
                    />
                    <h1>{perfil.nombre_usuario}</h1>
                    <br />
                    <h2>Correo</h2>
                    <p>{perfil.correo_electronico}</p>
                </div>
            </div>
        );
    }
};
